export class ImageResource {
  thumb: string = '/assets/custom-ion-icons/logo-tarraf-imobiliarias.svg';
  original: string = '/assets/custom-ion-icons/logo-tarraf-imobiliarias.svg';

  constructor(resource: ImageResource | null | undefined) {

    if (!resource) {
      return;
    }

    this.thumb = resource.thumb;
    this.original = resource.original;
  }
}
